let timelineElements = [
  {
    id: 1,
    title: "IIT BHU",
    location: "Varanasi,India",
    description:
      "Currently i am in third year of college.I am trying to explore web development(MERN) as well as django",
    buttonText: "View Frontend Projects",
    date: "Present",
    icon: "work",
  },
  {
    id: 2,
    title: "IIT BHU",
    location: "Varanasi,India",
    description:
      "After securing a good rank in jee i got electronics engineering at IIT BHU.The first year was very much exciting for me as this is the first time i am going to hostel in my life.In first year i learned basic programming ,started competetive programming and also participated in college fest in which i got to learn machine learning,computer vision.In second year i learned different data stuctures and algorithms to excel in competetive progrmming.",
    buttonText: "Course Certificate",
    date: "2019-2023",
    icon: "school",
  },
  {
    id: 3,
    title: "JEE Coaching",
    location: "Agra,India",
    description:
      "IIT JEE Coaching  - During these two years of coaching i worked hard and studied without any distractions.Jee preparation made me to cut off from the outer world but finally all the hard work payed off and i got into IIT BHU,Varanasi.",
    buttonText: "College Projects",
    date: "2017-2019",
    icon: "school",
  },
  {
    id: 4,
    title: "Simpkins School",
    location: "Agra,India",
    description:
      "Highschool - I completed my class 10th in AGRA.Like any other JEE candidate i also got 10/10 CGPA which made me to realize that i can also crack IIT JEE xD",
    date: "2017",
    icon: "school",
  },
];

export default timelineElements;
